import React from 'react'
import ReactDOM from 'react-dom'
// import './index.css'
import reportWebVitals from './reportWebVitals'


function importBuildTarget() {
  if (process.env.REACT_APP_BUILD_TARGET === 'admin') {
    //@ts-ignore
    return import('./admin')
  } else if (process.env.REACT_APP_BUILD_TARGET === 'catalog') {
    //@ts-ignore
    return import('./catalog')
  } else {
    return Promise.reject(
      new Error('No such build target: ' + process.env.REACT_APP_BUILD_TARGET)
    )
  }
}

importBuildTarget().then(({default: Environment}) =>
  ReactDOM.render(
    <React.StrictMode>
      <Environment/>
    </React.StrictMode>,
    document.getElementById('root')
  )
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log)
